import types from '../actions/types';

import {multipleResultReducer, multipleResultInitialState} from './common/multiple-results';

const initial_state = {
    partnerCategories: multipleResultInitialState
};

export default function (state = initial_state, action) {
    switch (action.type) {
        default:
            return {
                ...state,
                partnerCategories: multipleResultReducer(state.partnerCategories, types.LOAD_PARTNER_CATEGORIES, action)
            };
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/partnerCategories.js